import { inject, Injectable, DOCUMENT } from '@angular/core';
import { AppService } from './app.service';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

@Injectable({ providedIn: 'root' })
export class GtmService {
  private readonly doc = inject(DOCUMENT);

  pushEvent(gtags: Map<string, string>, event: Record<string, any> = {}) {
    const gTag = this.getGTag(gtags);
    if (!gTag) return; // No GTAG key exists for this environment. Just return

    this.initGTM(gTag);

    const sharedDataLayerData = this.getSharedDataLayerData();
    window.dataLayer ||= [];
    window.dataLayer.push(sharedDataLayerData);
    window.dataLayer.push({ ...sharedDataLayerData, ...event });
  }

  initGTM(gTag: string) {
    const scripts = [...Array.from(this.doc?.getElementsByTagName('script') || [])];
    const isSet = scripts.some((script) => script?.src.indexOf('https://www.googletagmanager.com/gtm.js') === 0);
    if (isSet) return;

    const s = this.doc.createElement('script');
    s.type = 'text/javascript';
    s.innerHTML = `(function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${gTag}')`;
    const head = this.doc.getElementsByTagName('head')[0];
    head.appendChild(s);
  }

  private getGTag(gtags: Map<string, string>) {
    const environment = AppService.get('environment');
    if (!environment) return undefined;
    return gtags.get(environment) || (environment === 'prod' ? undefined : gtags.get('nonprod'));
  }

  private getSharedDataLayerData() {
    return {
      appEnvironment: AppService.get('environment'),
      amplitudeGuidesApiKey: AppService.get('amplitudeGuidesApiKey'),
    };
  }
}
